
import "./js/inspinia";
import "./js/naming_agreement_test";
import "./js/testruns";
